module.exports = __webpack_public_path__ + "static/img/step-introduce-top.915dc199.png";